import { get, post, put, remove } from '@/utils/request';
import type { 
  EnterpriseInfo, 
  AddEnterpriseInfoParam, 
  ModifyEnterpriseInfoParam, 
  SearchEnterpriseInfoParam, 
  PageDTO 
} from '../baseInfo/type';

const BASE_URL = '/cmp-doc/baseInfo/enterpriseInfo';

/** 批量添加企业信息 */
export function saveEnterpriseInfo(data: AddEnterpriseInfoParam[]) {
  return post<any>(BASE_URL + '/save', data, {}, 'document');
}

/** 获取企业信息列表 */
export function getEnterpriseInfoList(params: SearchEnterpriseInfoParam) {
  return post<any>(BASE_URL + '/list', params, {}, 'document');
}

/** 删除企业信息 */
export function removeEnterpriseInfo(epIds: number[]) {
  return post<any>(BASE_URL + '/remove', epIds, {}, 'document');
}

/** 批量修改企业信息 */
export function modifyEnterpriseInfo(data: ModifyEnterpriseInfoParam[] ,) {
  return post<any>(BASE_URL + '/modify', data, {}, 'document');
} 